import React, { useState, useEffect, useCallback } from 'react';

import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreIcon from '@mui/icons-material/More';
import yellow from '@mui/material/colors/yellow';
import grey from '@mui/material/colors/grey';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TagIcon from '@mui/icons-material/Tag';

import deepOrange from '@mui/material/colors/deepOrange';

import { removeItemWithSlice, updateItemsWithIndexAndItem } from 'util/utils'
import { minutesToString } from "util/menuUtils";
import { filterCategoryItems } from "util/menuFilters";
import { describeOffShelf, isOffShelf } from "util/offShelf";

import {
    default as NewMenuItem
} from '../NewMenuItem'

import {
    default as MenuItem
} from '../MenuItem'

import {
    default as TargetBox
} from '../TargetBox'

import {
    saveMenuItems,

} from 'store/actions/restaurantMenu';
import {  useDispatch } from 'react-redux';
import { useConfirm } from 'material-ui-confirm';
import CategoryOptions from './CategoryOptions'
import MenuMiscSettings from './MenuMiscSettings'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
    },
    details: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    category: {
        // Grid `xs` sizes this column; a fixed 80% squeezed the action buttons
        // off the card on narrow screens.
        minWidth: 0,
    },
    content: {
        width: '100%',
    },
    idChip: {
        fontFamily: 'monospace',
        fontSize: '0.7rem',
        height: 20,
        backgroundColor: grey[100],
        border: `1px solid ${grey[300]}`,
        color: grey[600],
        cursor: 'text',
        userSelect: 'all',
    },
    cover: {
        width: 50,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 50,
        width: 50,
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
}));

const Category = (props) => {
    const { category, menuId, searchQuery = "", showIds = false, offShelfOnly = false, offShelfMap } = props;
    const classes = useStyles();

    const dispatch = useDispatch();
    const saveItems = (values) => dispatch(saveMenuItems(values));


    const [isNewMenuItem, setIsNewMenuItem] = useState(false)
    const [editMenuItem, setEditMenuItem] = useState(null)

    const [expanded, setExpanded] = useState(false);
    const [itemList, setItemList] = useState([]);

    const confirm = useConfirm();
    const [openMenuOptions, setOpenMenuOptions] = useState(false);
    const [openMenuSettings, setOpenMenuSettings] = useState(false);

    useEffect(() => {
        if (category.items) {
            setItemList(category.items);
        }

    }, [category.items]);

    const isFiltering = searchQuery.trim() !== "" || offShelfOnly;

    // Entries are `{item, index}`: `index` is the item's position in this category's own list, which is
    // what moveItem/moveItemToTop/handleDrop/moveGroup address. Filtering the list without carrying it
    // would point those callbacks at whichever dish sits at the same position in the unfiltered list.
    const filteredItemList = filterCategoryItems(itemList, {
        query: searchQuery,
        offShelfOnly,
        offShelfMap,
    });

    const offShelfCount = itemList.filter((item) => isOffShelf(item, offShelfMap)).length;

    const hasFilterMatch = isFiltering && filteredItemList.length > 0;
    const isExpanded = isFiltering ? hasFilterMatch : expanded;



    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const openNewMenuItem = () => {
        setIsNewMenuItem(true);

    };

    const closeNewMenuItem = () => {
        setIsNewMenuItem(false);

    };

    const updateItemList = (newItems) => {
        console.log('updateItemList');
        saveItems({ items: newItems, menuId: menuId, categoryId: category.id });
        setItemList(newItems);
    };

    const moveItem = (dragIndex, hoverIndex) => {
        console.log('moveItem', dragIndex, hoverIndex);
        let tempItems = [...itemList];
        [tempItems[dragIndex], tempItems[hoverIndex]] = [tempItems[hoverIndex], tempItems[dragIndex]];
        const newItems = tempItems.map((item, index) => {
            return { ...item, sort: index }
        });
        updateItemList(newItems);
    }

    const moveItemToTop = (currentIndex) => {
        // console.log('moveItemToTop', currentIndex);
        if (currentIndex === 0) {
            return; // Already at the top
        }
        let tempItems = [...itemList];
        const itemToMove = tempItems[currentIndex];
        tempItems.splice(currentIndex, 1);
        tempItems.unshift(itemToMove);
        const newItems = tempItems.map((item, index) => {
            return { ...item, sort: index }
        });
        updateItemList(newItems);
    }



    const deleteItem = (id) => {
        const updatedItemIndex = itemList.findIndex(
            item => item.id === id
        );
        if (updatedItemIndex !== -1) {
            const newItems = removeItemWithSlice(itemList, updatedItemIndex)
            updateItemList(newItems);
        }
    };

    const handleDrop = useCallback(
        (index, item) => {
            if (!item || !item.item) {
                return;
            }
            //console.log('category handledrop', index, item, category.items);
            let menuItem = category.items[index];
            //console.log('menuItem', menuItem);
            if (menuItem.groups) {
                let newGroups = [...menuItem.groups];
                if (newGroups.filter(group => group.id === item.item.id).length > 0) {
                    return
                }
                newGroups.push(item.item);
                menuItem.groups = newGroups;
            } else {
                menuItem.groups = [item.item];
            }
            let newItems = [...category.items];
            newItems[index] = menuItem;
            updateItemList(newItems);
        }, []);


    const moveGroup = (index, newGroups) => {
        let menuItem = category.items[index];
        //console.log('menuItem', menuItem);
        if (menuItem.groups) {
            menuItem.groups = newGroups;
            let newItems = [...category.items];
            newItems[index] = menuItem;
            updateItemList(newItems);
        }

    };

    const handleItemEdit = () => {
        props.editItem(true);
    };

    const handleDelete = () => {
        confirm({ description: 'You are about to delete this category!' })
            .then(() => {
                props.deleteCategory(category.id);
            })
            .catch(() => { /* ... */ });
    };

    const itemImage = (menuItemId) => {
        //console.log('itemImage', menuItemId, category.images);
        if (!category.images) {
            return
        }
        // const index = category.images.findIndex(image => image.menuItemId === menuItemId);
        // //console.log('itemImage', menuItemId, category.images, index);
        // if (index !== -1) {

        //     return category.images[index].imageUrl;
        // }
        return category.images[menuItemId];
    };


    const openMenuOptionsDialog = () => {
        setOpenMenuOptions(true);
    };

    const closeMenuOptions = () => {
        setOpenMenuOptions(false);
    };


    const openMenuSettingsDialog = () => {
        setOpenMenuSettings(true);
    };

    const closeMenuSettings = () => {
        setOpenMenuSettings(false);
    };


    const showWeekDays = (activeDays) => {
        let weekdays = '';
        if (activeDays && activeDays.length > 0) {
           weekdays = `on ${activeDays.join(',')}`;
        }
        return weekdays;
    };

    const hideWeekDays = (hideDays) => {
        let weekdays = '';
        if (hideDays && hideDays.length > 0) {
           weekdays = `on ${hideDays.join(',')}`;
        }
        return weekdays;
    };


    const handleMenuItemEdit = (menuItem) => {
        setEditMenuItem(menuItem);
        setIsNewMenuItem(true);
    };


    const handleMenuItemUpdate = (menuItem) => {
        console.log('handleMenuItemUpdate', menuItem)
        const itemsList = [...category.items]
        const itemIdx = itemsList.findIndex(item => item.id === menuItem.id);
        if (itemIdx !== -1) {
            const newItemsList = updateItemsWithIndexAndItem(itemList, itemIdx, menuItem);
            console.log('newItemsList', newItemsList);
            saveItems({ items: newItemsList, menuId: menuId, categoryId: category.id });
        }
    };

    return (
        <Card className={classes.root} >

            <CardContent >
                <Grid container direction="row" wrap="nowrap" alignItems="flex-start" justifyContent="space-between" spacing={2} >
                    <Grid item xs className={classes.category}>
                        <Grid container direction="row" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography component="h2" variant="h6" sx={{ fontWeight: 600 }}>
                                    {category.colorHex ? (
                                        <span className="selected-color" style={{ backgroundColor: category.colorHex }}>
                                            {category.name}
                                        </span>
                                    ) : category.name}
                                </Typography>
                            </Grid>
                            {category.items ? (
                                <Grid item>
                                    <Chip
                                        size="small"
                                        label={`${category.items.length} ${category.items.length === 1 ? 'item' : 'items'}`}
                                        style={{ backgroundColor: grey[200] }}
                                    />
                                </Grid>
                            ) : null}
                            {hasFilterMatch ? (
                                <Grid item>
                                    <Chip size="small" label={`${filteredItemList.length} match${filteredItemList.length > 1 ? 'es' : ''}`} color="primary" />
                                </Grid>
                            ) : null}
                            {!offShelfOnly && offShelfCount > 0 ? (
                                <Grid item>
                                    <Tooltip title="Dishes in this category customers cannot order right now">
                                        <Chip
                                            size="small"
                                            label={`${offShelfCount} off shelf`}
                                            style={{ backgroundColor: deepOrange[100] }}
                                        />
                                    </Tooltip>
                                </Grid>
                            ) : null}
                            {category.hideForWeb === true ? (
                                <Grid item>
                                    <Tooltip title="Hidden from web">
                                        <VisibilityOffIcon fontSize="small" color="action" />
                                    </Tooltip>
                                </Grid>
                            ) : null}
                        </Grid>
                        {showIds ? (
                        <Box mt={0.5}>
                            <Tooltip title="Category ID — click to select">
                                <Chip
                                    size="small"
                                    icon={<TagIcon style={{ fontSize: '0.75rem' }} />}
                                    label={category.id}
                                    className={classes.idChip}
                                />
                            </Tooltip>
                        </Box>
                        ) : null}
                        {category.altName ? (
                            <Typography variant="body2" color="textSecondary">
                                {category.altName}
                            </Typography>
                        ) : null}
                        {category.description ? (
                            <Typography variant="body2" color="textSecondary">
                                {category.description}
                            </Typography>
                        ) : null}
                        {category.cookingPriority ? (
                            <Typography variant="caption" color="textSecondary" display="block" mt={0.5}>
                                Cooking priority: {category.cookingPriority}
                            </Typography>
                        ) : null}
                        <Box display="flex" flexWrap="wrap" gap={0.5} mt={category.active === false || category.hidden_until || category.active_begin != null || category.hidden_begin != null ? 1 : 0}>
                            {!category.active ?
                                <Chip
                                    label={`Hidden from menu ${hideWeekDays(category.hideDays)}`}
                                    style={{ backgroundColor: yellow[700] }}
                                /> : null}
                            {category.hidden_until != null && category.hidden_until !== undefined ?
                                <Chip
                                    label={`Hidden until ${new Date(category.hidden_until).toLocaleString()}`}
                                    style={{ backgroundColor: yellow[700] }}
                                /> : null}

                            {category.active_begin !== null && category.active_begin !== undefined && category.active_end ?
                                <Chip
                                    label={`Show only from ${minutesToString(category.active_begin)} - ${minutesToString(category.active_end)} ${showWeekDays(category.activeWeekDays)}`}
                                    style={{ backgroundColor: yellow[700] }}
                                /> : null}
                            {category.hidden_begin != null && category.hidden_end != null ?
                                <Chip
                                    label={`Hidden during ${minutesToString(category.hidden_begin)} - ${minutesToString(category.hidden_end)} ${hideWeekDays(category.hiddenWeekDays)}`}
                                    style={{ backgroundColor: yellow[700] }}
                                /> : null}
                        </Box>
                    </Grid>

                    <Grid item sx={{ flexShrink: 0 }}>
                        <Box display="flex" alignItems="center">
                            <Tooltip title="Category settings">
                                <IconButton aria-label="category settings" size="small" color="secondary" onClick={openMenuSettingsDialog}>
                                    <SettingsOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Visibility and options">
                                <IconButton aria-label="category options" size="small" color="secondary" onClick={openMenuOptionsDialog}>
                                    <MoreIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Edit category">
                                <IconButton aria-label="edit category" size="small" color="secondary" onClick={handleItemEdit}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Delete category">
                                <IconButton aria-label="delete category" size="small" color="secondary" onClick={handleDelete}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={isExpanded ? "Hide dishes" : "Show dishes"}>
                                <IconButton
                                    className={clsx(classes.expand, {
                                        [classes.expandOpen]: isExpanded,
                                    })}
                                    onClick={handleExpandClick}
                                    aria-expanded={isExpanded}
                                    aria-label="show more"
                                    size="small"
                                    edge='end'
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            </Tooltip>

                            <CategoryOptions open={openMenuOptions} handClose={closeMenuOptions} category={category} menuId={menuId}
                            />
                            <MenuMiscSettings open={openMenuSettings} handClose={closeMenuSettings} category={category} menuId={menuId}/>
                        </Box>
                    </Grid>
                </Grid>

            </CardContent>
            <Divider />

            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <CardContent>

                    <Grid container direction="column">
                        {

                            filteredItemList.map(({ item, index }) => {

                                return <TargetBox
                                    accept={['item']}
                                    dragType={'item'}
                                    key={item.id}
                                    index={index}
                                    id={item.id}
                                    moveCard={moveItem}
                                >
                                    <MenuItem menuItem={{ ...item, image: itemImage(item.id) }} key={item.id}
                                        index={index} moveGroup={moveGroup}
                                        categoryId={category.id} menuId={menuId}
                                        deleteItem={deleteItem} editItem={handleMenuItemEdit}
                                        moveItemToTop={moveItemToTop} showIds={showIds}
                                        offShelf={describeOffShelf(item, offShelfMap)} />
                                </TargetBox>
                            })
                        }

                        {
                            isNewMenuItem ?
                                <NewMenuItem category={category} menuId={menuId} close={closeNewMenuItem} menuItem={editMenuItem} editItem={handleMenuItemUpdate} />

                                : null

                        }
                    </Grid>


                </CardContent>
                <Divider />
                <CardActions>

                    <Button variant="outlined" size="small" color="primary" onClick={openNewMenuItem}>
                        Add Item to {category.name}
                    </Button>
                </CardActions>
            </Collapse>

        </Card>
    );
};

export default Category;
